export default __webpack_public_path__ + "static/media/icons8-attach-96.b5abfe40.svg";